import { Box, Typography, Paper, Container, Chip } from '@mui/material';

const PERMISSION_CATEGORIES = [
  {
    label: 'User Management',
    color: '#90caf9',
    permissions: [
      { key: 'user:create', label: 'Create User' },
      { key: 'user:update', label: 'Update User' },
      { key: 'user:delete', label: 'Delete User' },
    ],
  },
  {
    label: 'Recruiter',
    color: '#a5d6a7',
    permissions: [
      { key: 'recruiter:view', label: 'View Recruiter' },
      { key: 'recruiter:edit', label: 'Edit Recruiter' },
    ],
  },
  {
    label: 'Job Orders',
    color: '#fff59d',
    permissions: [
      { key: 'joborder:view', label: 'View Job Order' },
      { key: 'joborder:edit', label: 'Edit Job Order' },
    ],
  },
  {
    label: 'Applications',
    color: '#ffab91',
    permissions: [
      { key: 'application:view', label: 'View Application' },
      { key: 'application:edit', label: 'Edit Application' },
      { key: 'application:create', label: 'Create Application' },
    ],
  },
  {
    label: 'Answers',
    color: '#ce93d8',
    permissions: [
      { key: 'answer:view', label: 'View Answer' },
      { key: 'answer:edit', label: 'Edit Answer' },
      { key: 'answer:create', label: 'Create Answer' },
    ],
  },
  {
    label: 'Organization',
    color: '#b0bec5',
    permissions: [
      { key: 'organization:view', label: 'View Organization' },
      { key: 'organization:edit', label: 'Edit Organization' },
      { key: 'organization:create', label: 'Create Organization' },
      { key: 'organization:delete', label: 'Delete Organization' },
    ],
  },
  {
    label: 'General',
    color: '#f48fb1',
    permissions: [
      { key: 'readonly', label: 'Read Only' },
    ],
  },
];

function getRandomRotation() {
  return Math.floor(Math.random() * 10 - 5); // -5 to +5 deg
}

export default function PermissionsPage() {
  return (
    <Container maxWidth="lg">
      <Paper elevation={2} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h4" gutterBottom>Permissions Overview</Typography>
        <Typography variant="subtitle1" sx={{ mb: 3 }}>
          All permissions in the system, grouped by category. For reference only.
        </Typography>
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 4,
          justifyContent: 'center',
        }}>
          {PERMISSION_CATEGORIES.map(category => (
            <Box
              key={category.label}
              sx={{
                minWidth: 220,
                p: 2,
                borderRadius: 3,
                boxShadow: 2,
                background: category.color,
                transform: `rotate(${getRandomRotation()}deg)`,
                mb: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>{category.label}</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {category.permissions.map(perm => (
                  <Chip
                    key={perm.key}
                    label={perm.label}
                    sx={{ fontWeight: 500, fontSize: 16, bgcolor: 'rgba(255,255,255,0.7)' }}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Paper>
    </Container>
  );
}
